import { getCookie } from '@/presentation/libs/cookie.lib';
import { getDefaultRouteFromAccessToken } from '@/presentation/router/defaultRoute.router';

const COMMON_ROUTES = Object.freeze({
	root: {
		path: '/',
		name: 'Root',
		meta: {
			layout: 'Default',
		},
		redirect: () => getDefaultRouteFromAccessToken(getCookie('access-token')),
	},
	search: {
		name: 'Search',
		path: 'search',
		component: () => import('@/presentation/views/SearchView.vue'),
		meta: { layout: 'Default', requiresBusinessInfo: false },
	},
	home: {
		name: 'Home',
		path: 'home',
		component: () => import('@/presentation/views/HomeView.vue'),
		meta: {
			layout: 'Default',
			requiresBusinessInfo: false,
		},
	},
	explore: {
		name: 'Explore',
		path: 'explore',
		component: () => import('@/presentation/views/ExploreView.vue'),
		meta: {
			requiresBusinessInfo: true,
		},
	},
	landing: {
		name: 'landing',
		path: '/landing',
		component: () => import('@/presentation/views/Landing.vue'),
		meta: {
			layout: 'Blank',
		},
	},
	installApp: {
		name: 'InstallApp',
		path: '/install-app',
		component: () => import('@/presentation/views/InstallAppView.vue'),
		meta: {
			layout: 'Blank',
			noindex: true,
		},
	},
	iosPwaInstallGuide: {
		name: 'IosPwaInstallGuide',
		path: '/install-app/ios',
		component: () => import('@/presentation/views/IosPwaInstallGuideView.vue'),
		meta: {
			layout: 'Blank',
			noindex: true,
		},
	},
	payment: {
		path: '/payment',
		name: 'PaymentRoot',
		redirect: {
			name: 'PaymentPreview',
		},
		children: [
			{
				name: 'PaymentPreview',
				path: 'preview',
				meta: {
					layout: 'Simple',
					requiresAuth: true,
					noindex: true,
				},
				component: () => import('@/presentation/views/payment/PreviewPaymentView.vue'),
			},
			{
				name: 'PaymentResult',
				path: ':id/result',
				meta: {
					layout: 'Simple',
					requiresAuth: true,
					noindex: true,
				},
				component: () => import('@/presentation/views/payment/ResultPaymentView.vue'),
			},
			{
				name: 'WalletPaymentResult',
				path: 'charge/wallet/result',
				meta: {
					layout: 'Simple',
					requiresAuth: true,
					noindex: true,
				},
				component: () => import('@/presentation/views/payment/ResultPaymentWalletView.vue'),
			},
		],
	},
	contactUs: {
		name: 'ContactUs',
		path: '/contact-us',
		props: true,
		meta: {
			layout: 'Default',
		},
		component: () => import('@/presentation/views/ContactUs.vue'),
	},
	termsAndCondition: {
		name: 'TermsAndCondition',
		path: '/terms-and-condition',
		props: true,
		meta: {
			layout: 'Simple',
		},
		component: () => import('@/presentation/views/TermsAndConditions.vue'),
	},
	disputeObjection: {
		name: 'DisputeObjection',
		path: '/dispute',
		props: true,
		meta: {
			layout: 'Simple',
		},
		component: () => import('@/presentation/views/DisputeObjectionView.vue'),
	},
	depositCancellationPolicy: {
		name: 'DepositCancellationPolicy',
		path: '/deposit-cancellation-policy',
		props: true,
		meta: {
			layout: 'Simple',
		},
		component: () => import('@/presentation/views/DepositCancellationPolicyView.vue'),
	},
	attendanceRespond: {
		name: 'AttendanceRespond',
		path: '/attendance/:action(confirm|cancel)',
		props: true,
		meta: {
			layout: 'Simple',
		},
		component: () => import('@/presentation/views/AttendanceRespondView.vue'),
	},
	waitlistOffer: {
		name: 'WaitlistOffer',
		path: '/waitlist-offer',
		props: true,
		meta: {
			layout: 'Simple',
		},
		component: () => import('@/presentation/views/WaitlistOfferView.vue'),
	},
	requestExpired: {
		name: 'RequestExpired',
		path: '/request-expired/:errorType',
		props: true,
		meta: {
			layout: 'Default',
		},
		component: () => import('@/presentation/views/RequestExpiredView.vue'),
	},
	notFound: {
		name: 'NotFound',
		path: '/:pathMatch(.*)*',
		meta: {
			layout: 'Default',
		},
		component: () => import('@/presentation/views/NotFoundView.vue'),
	},
});

export default COMMON_ROUTES;
